import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IInvalidInput, IGenericResponse } from '@interfaces/common';
import { IUserAgeRequest } from '@interfaces/myaccount';
import { UtilityService } from '@services/utility.service';
import { environment } from '@environments/environment';
import { SiteText } from '@constants/global';
import { NotificationService } from '@services/notification.service';
import { IChefMessageOptionsInterface } from 'chef-common/src/lib/chef-message/public-api';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-age-modal',
  templateUrl: './age-modal.component.html',
  styleUrls: ['./age-modal.component.scss']
})
export class AgeModalComponent implements OnInit {
  ageUpdateForm = new FormGroup({
    ageRange: new FormControl('', [Validators.required])
  });
  isFormValid: boolean = false;
  invalidInputs: Array<IInvalidInput> = [];
  errorObj: {[key: string]: string} = {
    ageRange: ''
  };
  messageOptions: IChefMessageOptionsInterface = {
    messageType: ''
  };

  constructor(private modal: NgbActiveModal, private utility: UtilityService, private notification: NotificationService, private user: UserService) { }

  ngOnInit(): void {
  }

  onSubmit(){
    this.isFormValid = true;
    this.invalidInputs = this.utility.filterInvalidInputs(this.ageUpdateForm);
    this.invalidInputs.forEach((elem: IInvalidInput) => {
      if(elem.error !== ''){
        this.errorObj[elem.field] = elem.error;
      }else{
        this.errorObj[elem.field] = '';
      }
    });
    if(this.invalidInputs.length === 0){
      this.isFormValid = false;
    }
    if(this.ageUpdateForm.valid){
      const payload: IUserAgeRequest = {
        age: this.ageUpdateForm.controls.ageRange.value
      };
      this.messageOptions.messageType = '';
      const subs = { 
        next: (response: IGenericResponse) => {
          if(response.response.code === '0000'){
            this.user.updateUserInfo('age', payload.age);
            this.notification.showNotification('success', response.response.message);
            this.modal.close();
          }else if(response.response.code === '1010'){
            this.messageOptions = this.utility.getMsgOptionsObj('error', response.response.message);
          }else{
            this.notification.showNotification('error', response.response.message);
          }
        },
        error: (e: any) =>{
          console.log(e);
          this.notification.showNotification('error', SiteText.TECHNICAL_ERROR);
        }};
      this.utility.sendRequest<IGenericResponse>(environment.updateUserAge, payload).subscribe(subs);
    }
  }

  closeModal() {
    this.modal.dismiss();
  }

}
